
import {
    GET_EVENT_LIST,
    UPDATE_EVENT_LOADING_STATUS,
  } from "../actions/eventConfig";
  
  const defVal = {
    eventList: [],
    loading: true,
  };
  
  export default (state = defVal, action) => {
    switch (action.type) {
      case GET_EVENT_LIST:
        return Object.assign({}, state, {
          eventList: action.eventList,
        });
      case UPDATE_EVENT_LOADING_STATUS:
        return Object.assign({}, state, {
          loading: action.loading
        });
      default:
        return state;
    }
  };
  